<template>
    <el-dialog
        title="评委管理"
        :visible.sync="dialogSign"
        width="1000px" :close-on-click-modal="false">
        <div class="judegeslist">
            <div class="judegeslistTitle">
                评委添加
            </div>
            <div class="judges">
                <div class="searchItem">
                    <div class="name">姓名</div>
                    <el-select filterable clearable v-model="topForm.userUuid" placeholder="姓名">
                        <el-option
                            v-for="(item,index) in judgeList"
                            :key="index"
                            :label="item.name"
                            :value="item.uuid">
                        </el-option>
                    </el-select>
                </div>
                <div class="searchItem">
                    <div class="name">赛道信息</div>
                    <el-select v-model="topForm.activityWayUuid" filterable
                               @change="getTypeInfo"
                               clearable placeholder="请选择">
                        <el-option
                            v-for="item in wayList"
                            :key="item.uuid"
                            :label="item.name"
                            :value="item.uuid">
                        </el-option>
                    </el-select>
                </div>
                <div class="searchItem" v-if="typeList.length>0">
                    <div class="name">赛道类别</div>
                    <el-select v-model="topForm.activityType" filterable clearable multiple placeholder="请选择">
                        <el-option
                            v-for="item in typeList"
                            :key="item.uuid"
                            :label="item.worksType"
                            :value="item.uuid">
                        </el-option>
                    </el-select>
                </div>
                <el-button class="searchBtn" @click="addActivityInfo">添加</el-button>
            </div>

        </div>

        <div class="orderListTable">
            <div class="judegeslistTitle">评委管理列表</div>
            <el-table
                height="520"
                :data="tableData"
                border
                style="width: 100%" class="tableContent">
                <el-table-column
                    prop="userName"
                    label="姓名"
                    header-align="center"
                    show-overflow-tooltip
                    align="center">
                </el-table-column>
                <el-table-column
                    prop="activityWayName"
                    align="center"
                    header-align="center"
                    label="赛道名称">
                </el-table-column>
                <el-table-column
                    prop="worksType"
                    align="center"
                    header-align="center"
                    label="赛道分类">
                </el-table-column>
                <el-table-column
                    prop="telephone"
                    align="center"
                    header-align="center"
                    label="联系电话">
                </el-table-column>
                <el-table-column
                    label="操作"
                    header-align="center"
                    align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="deleteInfo(scope.row.uuid)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                class="curren"
                background
                @current-change="handleCurrentChange"
                @prev-click="handleCurrentChange"
                @next-click="handleCurrentChange"
                layout="total,prev, pager, next,jumper"
                :current-page="current"
                :page-size="pageSize"
                :total="total">
            </el-pagination>
        </div>
    </el-dialog>

</template>

<script>
    import {
        getJudgeList, getActivityWayList, getActivityTypeList,
        saveActivityJudge, getActivityJudgeInfo,
        getActivityJudgeList, deleteActivityJudge
    } from '../../../utils/interface';

    export default {
        name: "judgesDialog",
        data() {
            return {
                dialogSign: false,
                topForm: {
                    userUuid: '',
                    activityWayUuid: '',
                    activityType: '',
                    type: '',
                    activityUuid: '',
                },
                judgeList: [],
                tableData: [],
                current: 1,
                pageSize: 10,
                total: 0,
                wayList: [],
                typeList:[],
                type: "",
            }
        },
        methods: {
            init(type, uuid) {
                this.reset();
                this.type = type;
                this.dialogSign = true;
                this.topForm.activityUuid = uuid;
                // 查询评委库用户
                getJudgeList({type: type, survival: "ENABLE"}).then((res) => {
                    this.judgeList = res;
                });
                // 查询赛道类别
                getActivityWayList({activityUuid: uuid}).then((res) => {
                    this.wayList = res;
                });
                this.getList();
            },
            getTypeInfo(){
                getActivityTypeList({activityWayUuid: this.topForm.activityWayUuid}).then((res) => {
                    this.typeList = res.data;
                });
            },
            getList() {
                let params = {
                    activityUuid: this.topForm.activityUuid,
                    type: this.type,
                    current: this.current,
                    pageSize: this.pageSize,
                }
                // 查询列表数据
                getActivityJudgeList(params).then((res) => {
                    this.total = res.total;
                    this.tableData = res.list;
                });
            },
            reset() {
                this.topForm = {
                    userUuid: '',
                    activityWayUuid: '',
                    activityType: '',
                    type: '',
                    activityUuid: '',
                }
            },
            addActivityInfo() {
                if (this.topForm.userUuid == '') {
                    this.$message.error("请选择用户");
                    return;
                }
                if (this.topForm.activityWayUuid == '') {
                    this.$message.error("请选择作品赛道");
                    return;
                }
                if (this.typeList.length>0 && this.topForm.activityType == '') {
                    this.$message.error("请选择作品类别");
                    return;
                }
                // 添加之前先校验
                getActivityJudgeInfo({
                    userUuid: this.topForm.userUuid, type: this.type,
                    activityWayUuid: this.topForm.activityWayUuid,
                    activityUuid:this.topForm.activityUuid
                }).then((res) => {
                    if (res.success) {
                        if (res.data != null) {
                            this.$message.error("该评委已经存在于活动中,如需添加,请先删除已存在的评委！");
                        } else {
                            this.topForm.activityType = this.topForm.activityType.join(',');
                            this.topForm.type = this.type;
                            saveActivityJudge(this.topForm).then((res) => {
                                if (res.success) {
                                    this.topForm.activityType = this.topForm.activityType.split(',');
                                    this.$message.success("保存成功");
                                    this.getList();
                                    this.topForm.activityWayUuid = "";
                                    this.topForm.activityType = "";
                                    this.topForm.userUuid = "";                                    //this.$emit("submit");
                                }
                            });
                        }
                    }
                });
            },
            // 分页
            handleCurrentChange(val) {
                this.current = val;
                this.getList();
            },
            deleteInfo(uuid) {
                this.$confirm('确定要移除当前用户嘛？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteActivityJudge({uuid: uuid}).then((res) => {
                        if (res.success) {
                            this.$message.success("删除成功");
                            this.getList();
                        }
                    });
                });
            },
        }
    }
</script>

<style scoped lang="less">
    .orderListTable {
        .judegeslistTitle {
            font-size: 18px;
            font-weight: bold;
            margin-bottom: 10px;
            margin-top: 40px;
        }

        .curren {
            margin-top: 20px;
            text-align: right;

        }
    }

    .judegeslist {
        .judegeslistTitle {
            font-size: 18px;
            font-weight: bold;
            margin-bottom: 10px;
        }

        .judges {
            display: flex;
            align-items: center;
            margin-bottom: 20px;

            .searchItem {
                display: flex;
                align-items: center;
                margin-right: 20px;

                .name {
                    padding-right: 20px;
                    flex-shrink: 0;
                }

                /deep/ .el-input {
                    width: 100%;
                }
            }

            .searchBtn {
                width: 82px;
                background: #3d7fff;
                border: none;
                border-radius: 15px;
                font-size: 14px;
                color: #ffffff;
            }
        }
    }


</style>



// WEBPACK FOOTER //
// src/views/activityManagement/activeDialog/judgesDialog.vue